import { ref, watch } from 'vue';
import { useSignalR } from '@siclop/kstone-vue';
import { useAuthStore } from '@/stores/auth.store';

/**
 * Cycle de vie de la connexion SignalR pour THE HO! La synchronisation
 * temps-réel des entités est gérée nativement par `createKsStore` (qui
 * s'abonne à `Maj{ModelName}` via signalRStoreManager en interne). Ce
 * composable se contente de connecter / déconnecter en fonction de
 * l'état d'authentification. À appeler une fois dans App.vue.
 */

const initialized = ref(false);

export function useTheHoSignalR() {
  const auth = useAuthStore();
  const { isConnected, connect, disconnect } = useSignalR();

  async function init(): Promise<void> {
    if (initialized.value) return;
    initialized.value = true;

    watch(
      () => auth.isAuthenticated,
      async (authed) => {
        try {
          if (authed) await connect();
          else await disconnect();
        } catch (err) {
          // SignalR optionnel — n'empeche pas l'app de marcher MAIS on ne
          // l'avale plus en silence : sans temps-reel, la synchro des stores
          // (createKsStore -> Maj{Model}) ne se fait pas et les listes ne se
          // rafraichissent pas toutes seules. On le surface pour diagnostic
          // (negociation 401 / CORS / hub injoignable...).
          console.warn(
            '[SignalR] connexion echouee — synchro temps-reel desactivee. '
            + 'Les listes admin ne se mettront a jour que sur action locale / refresh.',
            err,
          );
        }
      },
      { immediate: true },
    );
  }

  return { init, isConnected };
}
